/**
 * @const {object}
 * @memberOf module:Reporting
 */
export const reportingAudit = {
    /* @ngInject */
    controller: function ($ngRedux, $state, $rootScope, FileActions) {
        /**
         * @function $onInit
         */
        this.$onInit = () => {
            this.unsubscribe = $ngRedux.connect(() => ({}), {
                ...FileActions
            })(this);
        };

        this.onReset = (event) => {
            $rootScope.$broadcast('SELECT_CASCADE_RESET', 'reportingAuditFilterForm');
        };

        this.onDownloadButton = ( {item} ) => {
            this.download( `storage${item.uri}` );
        };

        this.$onDestroy = () => {
            this.unsubscribe();
        };
    },
    template: `
        <reporting-audit-grid 
            on-download="$ctrl.onDownloadButton($event)"
            on-reset="$ctrl.onReset($event)">
        </reporting-audit-grid>
    `
};
